import { getExternalURL } from "./getExternalURL";

export type GetExternalQuoteFormURL = (countryCode: string, formId: string) => string | undefined;

export const getExternalQuoteFormURL: GetExternalQuoteFormURL = (countryCode, formId = "") => {
  const externalURL = getExternalURL(`${countryCode}.ci.quoteForm`, { formId });
  return externalURL ? externalURL : undefined;
};
